goog.provide("shadow.js.shim.module$src$svg$editor$emoji$thumbs_up_svg$default");
shadow.js.shim.module$src$svg$editor$emoji$thumbs_up_svg$default = shadow.js.shim.module$src$svg$editor$emoji$thumbs_up_svg.default;
